// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-status-heading{
  font-size: 17px;
  margin: 0px;
}

.amount{
  background-color: #000000;
  padding: 10px;
  color: #ffffff;
  display: inline-block;
}

.value{
  word-break: break-all;
  word-wrap: break-word;
}

.payment-details-container{
  display: flex;
  flex-direction: column;
  /* align-items: center; */
}

.payer-table-details-web{
  display: none;
}

.payer-details-card{
  border: 1px solid #cfd3d6;
  border-radius: 5px;
}

.payer-details-field-container{
  display: flex;
  justify-content: space-between;
}

.payer-details-field-key{
  font-size: 14px;
}

.payer-details-field-value{
  display: flex;
  justify-content: flex-end;
  width: 72%;
  font-size: 13px;
  font-weight: 500;
  /* word-wrap: break-word; */
  word-break: break-all;
}

.school-details-heading{
  font-weight: 500;
  font-size: 18px;
}

.payment-footer{
  background-color: #000000;
  color: #ffffff;
  padding: 10px;
  text-align: center;
}
@media (min-width :768px){
  .payer-table-details-mobile{
      display: none;
  }
  .payment-details-container{
      flex-direction: row;
      justify-content: space-between;
  }
  .payer-table-details-web{
      display: block;
  }
}

.check{
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/paymentStatus/PaymentStatus.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;AACA;EACE;MACI,aAAa;EACjB;EACA;MACI,mBAAmB;MACnB,8BAA8B;EAClC;EACA;MACI,cAAc;EAClB;AACF;;AAEA;EACE,aAAa;AACf","sourcesContent":[".payment-status-heading{\n  font-size: 17px;\n  margin: 0px;\n}\n\n.amount{\n  background-color: #000000;\n  padding: 10px;\n  color: #ffffff;\n  display: inline-block;\n}\n\n.value{\n  word-break: break-all;\n  word-wrap: break-word;\n}\n\n.payment-details-container{\n  display: flex;\n  flex-direction: column;\n  /* align-items: center; */\n}\n\n.payer-table-details-web{\n  display: none;\n}\n\n.payer-details-card{\n  border: 1px solid #cfd3d6;\n  border-radius: 5px;\n}\n\n.payer-details-field-container{\n  display: flex;\n  justify-content: space-between;\n}\n\n.payer-details-field-key{\n  font-size: 14px;\n}\n\n.payer-details-field-value{\n  display: flex;\n  justify-content: flex-end;\n  width: 72%;\n  font-size: 13px;\n  font-weight: 500;\n  /* word-wrap: break-word; */\n  word-break: break-all;\n}\n\n.school-details-heading{\n  font-weight: 500;\n  font-size: 18px;\n}\n\n.payment-footer{\n  background-color: #000000;\n  color: #ffffff;\n  padding: 10px;\n  text-align: center;\n}\n@media (min-width :768px){\n  .payer-table-details-mobile{\n      display: none;\n  }\n  .payment-details-container{\n      flex-direction: row;\n      justify-content: space-between;\n  }\n  .payer-table-details-web{\n      display: block;\n  }\n}\n\n.check{\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
